import { useQuery } from "@apollo/client/react";
import type { CheckSessionQuery } from "../../api.generated";
import { checkSessionQuery } from "./queries";

export const useCheckSession = (authToken?: string) =>
  useQuery<CheckSessionQuery>(checkSessionQuery, {
    pollInterval: 3600000,
    skip: !authToken || authToken.endsWith("undefined"),
  });
